var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"69e8af632f159e83984299adb206d2c9e2583e71"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["booklick-web@booklick"]={id:"69e8af632f159e83984299adb206d2c9e2583e71"};
      